// Auto-generated file - do not edit manually
export const LOCALE_HASH = '9a488802';
